import {v4 as uuidv4} from 'uuid';

export const user = {
    name: "Evano",
    position: "Project Manager",
}
//---------------------------------------------------
const customers = [
    {
        id: uuidv4(),
        customerName: "Jane Cooper",
        company: "Microsoft",
        phoneNumber: "(225) 555-0118",
        email: "jane@microsoft.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Floyd Miles",
        company: "Yahoo",
        phoneNumber: "(205) 555-0100",
        email: "floyd@yahoo.com",
        country: "Kiribati",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ronald Richards",
        company: "Adobe",
        phoneNumber: "(302) 555-0107",
        email: "ronald@adobe.com",
        country: "Israel",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Marvin McKinney",
        company: "Tesla",
        phoneNumber: "(252) 555-0126",
        email: "marvin@tesla.com",
        country: "Iran",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Jerome Bell",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "jerome@google.com",
        country: "Réunion",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Kathryn Murphy",
        company: "Microsoft",
        phoneNumber: "(406) 555-0120",
        email: "kathryn@microsoft.com",
        country: "Curaçao",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Jacob Jones",
        company: "Yahoo",
        phoneNumber: "(208) 555-0112",
        email: "jacob@yahoo.com",
        country: "Brazil",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Kristin Watson",
        company: "Facebook",
        phoneNumber: "(704) 555-0127",
        email: "kristin@facebook.com",
        country: "Åland Islands",
        status: false,
    },

    {
        id: uuidv4(),
        customerName: "John Smith",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "john@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Alice Johnson",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "alice@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Bob Davis",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "bob@instagram.com",
        country: "United Kingdom",
        status: true,
    },

    {
        id: uuidv4(),
        customerName: "John Doe",
        company: "Apple",
        phoneNumber: "(123) 555-4567",
        email: "john@apple.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Alice Johnson",
        company: "Amazon",
        phoneNumber: "(987) 555-4321",
        email: "alice@amazon.com",
        country: "Canada",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Bob Smith",
        company: "Google",
        phoneNumber: "(345) 555-6789",
        email: "bob@google.com",
        country: "Australia",
        status: true,
    },

    {
        id: uuidv4(),
        customerName: "David Miller",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "david@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emily White",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "emily@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Michael Brown",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "michael@pinterest.com",
        country: "Spain",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Alex Johnson",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "alex@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sarah Davis",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "sarah@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ryan Smith",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "ryan@instagram.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emma White",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "emma@snapchat.com",
        country: "Germany",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Jack Miller",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "jack@whatsapp.com",
        country: "France",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Olivia Brown",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "olivia@pinterest.com",
        country: "Spain",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Noah Wilson",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "noah@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Ava Taylor",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "ava@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Liam Martinez",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "liam@pinterest.com",
        country: "Spain",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophia Adams",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "sophia@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Michael Johnson",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "michael@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emily Davis",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "emily@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ryan Smith",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "ryan@instagram.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emma White",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "emma@snapchat.com",
        country: "Germany",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Jack Miller",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "jack@whatsapp.com",
        country: "France",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Olivia Brown",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "olivia@pinterest.com",
        country: "Spain",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Noah Wilson",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "noah@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Ava Taylor",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "ava@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Liam Martinez",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "liam@pinterest.com",
        country: "Spain",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophia Adams",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "sophia@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Daniel Turner",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "daniel@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophie White",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "sophie@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ethan Miller",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "ethan@instagram.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Olivia Brown",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "olivia@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Mia Wilson",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "mia@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Logan Davis",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "logan@pinterest.com",
        country: "Spain",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Aiden Smith",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "aiden@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Ella Taylor",
        company: "Facebook",
        phoneNumber: "(704) 555-0127",
        email: "ella@facebook.com",
        country: "Åland Islands",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ava Taylor",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "ava@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Liam Martinez",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "liam@pinterest.com",
        country: "Spain",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophia Adams",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "sophia@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Michael Johnson",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "michael@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emily Davis",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "emily@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ryan Smith",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "ryan@instagram.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Emma White",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "emma@snapchat.com",
        country: "Germany",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Jack Miller",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "jack@whatsapp.com",
        country: "France",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Olivia Brown",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "olivia@pinterest.com",
        country: "Spain",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Noah Wilson",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "noah@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Ava Taylor",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "ava@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Liam Martinez",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "liam@pinterest.com",
        country: "Spain",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophia Adams",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "sophia@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Daniel Turner",
        company: "Snapchat",
        phoneNumber: "(876) 555-9876",
        email: "daniel@snapchat.com",
        country: "Germany",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Sophie White",
        company: "LinkedIn",
        phoneNumber: "(345) 555-4321",
        email: "sophie@linkedin.com",
        country: "Australia",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Ethan Miller",
        company: "Instagram",
        phoneNumber: "(123) 555-4567",
        email: "ethan@instagram.com",
        country: "United Kingdom",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Olivia Brown",
        company: "WhatsApp",
        phoneNumber: "(543) 555-7890",
        email: "olivia@whatsapp.com",
        country: "France",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Mia Wilson",
        company: "Twitter",
        phoneNumber: "(987) 555-6789",
        email: "mia@twitter.com",
        country: "Canada",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Logan Davis",
        company: "Pinterest",
        phoneNumber: "(210) 555-6543",
        email: "logan@pinterest.com",
        country: "Spain",
        status: false,
    },
    {
        id: uuidv4(),
        customerName: "Aiden Smith",
        company: "Google",
        phoneNumber: "(629) 555-0129",
        email: "aiden@google.com",
        country: "United States",
        status: true,
    },
    {
        id: uuidv4(),
        customerName: "Ella Taylor",
        company: "Facebook",
        phoneNumber: "(704) 555-0127",
        email: "ella@facebook.com",
        country: "Åland Islands",
        status: false,
    },

];





export default customers;